// Erklärtext über einer Liste (Text aus dem Code).
import type { ReactNode } from 'react';

export function FormText({ children, leer }: { children: ReactNode; leer?: boolean }) {
  return leer ? (
    <p style={{ margin: 0, padding: 22, borderRadius: 20, textAlign: 'center', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.45)', border: '1px dashed rgba(255,255,255,0.14)' }}>{children}</p>
  ) : (
    <p style={{ margin: 0, padding: '0 4px', fontSize: 12.5, fontWeight: 600, lineHeight: 1.5, color: 'rgba(255,255,255,0.55)' }}>{children}</p>
  );
}
